import FaIconUvilo, { type FaIconSize } from '@erikdakoda/ui/components/FaIconUvilo';
import type { TodoState } from '@erikdakoda/database/enums';
import { TODO_STATE_META } from '../types';

type TodoStateIconProps = {
  state: TodoState;
  size?: FaIconSize;
};

/**
 * Font Awesome icon for a todo item state.
 */
export default function TodoStateIcon({ state, size = 'md' }: TodoStateIconProps) {
  'use memo';

  const meta = TODO_STATE_META[state];

  return (
    <FaIconUvilo
      className="todo-state-icon"
      icon={meta.icon}
      prefix={meta.prefix}
      size={size}
      square
      sx={{ color: meta.color }}
    />
  );
}
